import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader,
  ButtonOBSOLETED,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import { Filters, FilterInput, FilterSelect } from './Filters';
import { getQueryStringParameters } from '../../common/utils';
import { mappedProviderTypes } from '../../enums/ProviderTypes';
import {
  DisplayGuid,
  DisplayDate,
  DisplayType,
  DisplayBoolean
} from '../items';
import AddEntityButton from '../misc/AddEntityButton';

const resultsCount = 15;

class ProvidersInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  componentDidMount() {
  }

  goToPage(number) {
    // TODO consider to move responsability to filter component
    const { history, location } = this.props;
    const filters = Object.assign(
      {},
      getQueryStringParameters(location.search),
      {
        page: number
      });
    const search = Object.keys(filters)
      .filter(key => key && filters[key])
      .map(key => `${key}=${encodeURIComponent(filters[key])}`).join('&');
    history.push(`?${search}`);
  }

  async loadData(filters, skipPages) {
    const { props: { api: { providers: { searchProvider } } } } = this;

    this.setState({ isLoading: true });
    let result = null;

    try {
      result = await searchProvider({ filters, skipPages, resultsCount });
    }
    catch (e) {
      console.error(`unable to load. ${e}`);
      this.setState({ isLoading: false, errorMessage: new Message('error', 'Unable to load data') });

      return;
    }

    this.setState({ isLoading: false });

    return result;
  }

  render() {
    const { location } = this.props;
    const { isLoading, errorMessage } = this.state;
    const parameters = getQueryStringParameters(location.search);
    const pageNumber = parameters.page ? parseInt(parameters.page, 10) : 1;
    const { history, categories } = this.props;
    const mappedCategories = categories.map(({ Name }) => ({ value: Name, label: Name }));

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />
            <PageTop
              documentTitle='Providers page'
              documentDescription='Providers page'
            />

            <h2 className='main-page-header'>
              Providers
              <AddEntityButton to='/provider' />
            </h2>

            <Filters
              initFromUrl
              submitUrl
              validateForm={({
                providerId,
                name,
                type,
                category
              }, updatedKey) => {
                if (updatedKey !== 'providerId') {
                  return {
                    name,
                    type,
                    category
                  };
                }
                return { providerId };
              }}
              render={(formData, update) => (
                <div className='filters-block'>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='providerId'>
                      Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='providerId'
                      placeholder='Find by id'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='name'>
                      Name
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name='name'
                      placeholder='Filter by name'
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='type'>
                      Type
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='type'
                      options={mappedProviderTypes}
                    />
                  </div>
                  <div className='filters-label-block'>
                    <label className='filters-label' htmlFor='category'>
                      Category
                    </label>
                    <FilterSelect
                      className='filter-select'
                      data={formData}
                      update={update}
                      name='category'
                      options={mappedCategories}
                    />
                  </div>
                  <br />
                  <br />
                  <div className='filters-submit-wrapper'>
                    <ButtonOBSOLETED type='submit' buttonContent='Search' disabled={isLoading} />
                  </div>
                  <hr />
                </div>
              )}
            />
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'providers',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/provider/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'Name',
                    label: 'Name',
                    type: 'string'
                  },
                  {
                    property: 'Category',
                    label: 'Category',
                    type: 'string'
                  },
                  {
                    property: 'Type',
                    label: 'Type',
                    type: 'string',
                    render: ({ Type }) => <DisplayType>{Type}</DisplayType>
                  },
                  {
                    property: 'CreatedAtCet',
                    label: 'Created At (CET)',
                    render: ({ CreatedAtCet }) => <DisplayDate>{CreatedAtCet}</DisplayDate>
                  },
                  {
                    property: 'IsPublic', // TODO fix ispublic
                    label: 'Is Public',
                    type: 'bool',
                    render: ({ IsPublic }) => <DisplayBoolean>{IsPublic}</DisplayBoolean>
                  }
                ]
              }}
              getData={async newPageNumber => {
                const filters = getQueryStringParameters(location.search);

                return this.loadData(filters, newPageNumber || 1);
              }}
              paginationData={{
                renderLocation: 'both',
                rowsPerPage: resultsCount,
                pageNumber,
                goToPageNumber: number => this.goToPage(number)
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Providers = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ProvidersInternal)
));

Providers.requiresLogin = true;
Providers.propTypes = { isLoggedIn: PropTypes.bool };

export default Providers;
